export default __webpack_public_path__ + "e63050257ed562c5483027288b28606d.woff";